import { openDB as realOpenDB } from 'idb';

export const openDB = realOpenDB;

export const createSetIDBValue = (dbInstance) => async (storeName, value) => {
  return await (await dbInstance).put(storeName, value);
};

export const createDeleteIDBValueByKey = (dbInstance) => async (storeName, key) => {
  return await (await dbInstance).delete(storeName, key);
};

export const createGetIDBValueByKey = (dbInstance) => async (storeName, key) => {
  return await (await dbInstance).get(storeName, key);
};

export const createGetAllIDBValues = (dbInstance) => async (storeName) => {
  return await (await dbInstance).getAll(storeName);
};
